import Spinner from "src/components/common/Spinner";
import { PortaledModalFrame } from "src/components/common/PortaledModalFrame";

export interface BatchUpdateProgressModalProps {
  open: boolean;
  message: string;
}

/**
 * Non-dismissable progress overlay (same role as desktop LoadingDialog during batch update).
 */
export function BatchUpdateProgressModal({ open, message }: BatchUpdateProgressModalProps) {
  if (!open) return null;

  return (
    <PortaledModalFrame onClose={() => {}} panelClassName="max-w-sm" panelStyle={{ maxWidth: 400 }}>
      <div className="px-8 py-10 flex flex-col items-center text-center">
        <div className="[&_svg]:text-[#FD7657] [&_path.fill-orange]:fill-[#FD7657]">
          <Spinner />
        </div>
        <p className="mt-5 text-sm font-medium text-[#374151]">{message}</p>
      </div>
    </PortaledModalFrame>
  );
}
